import { render, staticRenderFns } from "./ProdMenu.vue?vue&type=template&id=4c087938&"
import script from "./ProdMenu.vue?vue&type=script&lang=js&"
export * from "./ProdMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports